import React from "react";
import { Box, Typography, Hidden } from "@material-ui/core";
import { StoreLabelType } from "../../constants";
import { useLabelsFilter } from "../../utils";
import useTranslate from "../../../../hooks/use-translate";
import LabelsFilter from "../TopBar/LabelsFilter";

type Props = {
  labels: StoreLabelType[];
};

const ActiveFilters = ({ labels }: Props) => {
  const t = useTranslate();

  const { filterLabels, handleLabelFilterClick } = useLabelsFilter(labels);
  const selectedFilterLabels = filterLabels.filter(l => l.isSelected);

  return (
    <>
      {selectedFilterLabels.length > 0 && (
        <Hidden mdUp>
          <Box marginTop={3}>
            <Typography variant="body2">
              {t("storeLocator.filteredBy")}
            </Typography>
            <Box marginTop={1}>
              <LabelsFilter
                labels={selectedFilterLabels}
                onLabelClick={handleLabelFilterClick}
              />
            </Box>
          </Box>
        </Hidden>
      )}
    </>
  );
};

export default ActiveFilters;
